module.exports = __webpack_public_path__ + "img/chevron_right.de6f58ea.svg";